import { createReducer, on } from '@ngrx/store';
import * as FlowActions from './flow.actions';

export interface FlowState {
    context: string | null; // current flow context
    selectedIds: string[]; // items đang chọn (ví dụ product ids)
}

export const initialState: FlowState = {
    context: null,
    selectedIds: [],
};

export const flowReducer = createReducer(
    initialState,

    // set context lần đầu hoặc init
    on(FlowActions.setContext, (state, { context }) => ({
        ...state,
        context,
    })),

    // clear selection khi flow thay đổi, đồng thời set context mới
    on(FlowActions.clearContext, (state, { newContext }) => ({
        ...state,
        context: newContext,
        selectedIds: [], // reset các item đã chọn
    })),

    // preserve context, giữ nguyên selection
    on(FlowActions.preserveContext, (state, { context }) => ({
        ...state,
        context,
        // selectedIds giữ nguyên
    })),
    on(FlowActions.clearContext, (state, { newContext }) => ({
        ...state,
        context: newContext, // set luôn context mới
        selectedIds: [], // clear selection
    }))
);
